import React, { ImgHTMLAttributes, useMemo } from "react";

type ImageProps = ImgHTMLAttributes<HTMLImageElement> & {
  responsiveWidth?: number;
  className?: string;
};

const MEDIA_URL_REGEX =
  /^(?:https?:\/\/)?(?:[^@/\n]+@)?(?:www\.)?([^:/?\n]+)(.+)/;

function extractUrlMetadata(url: string) {
  const match = url.match(MEDIA_URL_REGEX);
  const domain = match?.[1];
  const path = match?.[2];
  return {
    domain,
    path,
  };
}

export default function Image({
  src,
  alt,
  className,
  responsiveWidth,
  ...rest
}: ImageProps) {
  const responsiveSrc = useMemo(() => {
    let newSrc = src;
    if (src && responsiveWidth) {
      const { domain, path } = extractUrlMetadata(src);
      if (domain && path) {
        newSrc = `https://${domain}/cdn-cgi/image/width=${responsiveWidth}${path}`;
      }
    }
    return newSrc;
  }, [responsiveWidth, src]);
  return <img src={responsiveSrc} alt={alt} className={className} {...rest} />;
}
